import { FormFieldConfig, PossibleFormFieldValues } from "../../interfaces/IForms";
import { Gender, getGenderOptions, getGenderTranslation } from "../../interfaces/enums";
import { GridColDef } from "@mui/x-data-grid";
import { validateYear } from "../../utils/dates";

// ----------------------------------------------------- //
// ------------------ FORMULARZE ------------------- //
// ----------------------------------------------------- //

export const newParticipantFormFields: FormFieldConfig<PossibleFormFieldValues>[] = [
  {
    key: "firstName",
    label: "Imię",
    value: "",
    required: true,
    type: "text",
    validators: [
      (value) => (!value ? "To pole jest wymagane" : ""),
      (value) =>
        typeof value === "string" && value.length >= 2 ? "" : "Imię musi mieć co najmniej 2 znaki",
      (value) =>
        /^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ-]+$/.test(value as string)
          ? ""
          : "Imię może zawierać tylko litery i znak '-'",
      (value) => (!/\s/.test(value as string) ? "" : "Imię nie może zawierać spacji"),
    ],
  },
  {
    key: "lastName",
    label: "Nazwisko",
    value: "",
    required: true,
    type: "text",
    validators: [
      (value) => (!value ? "To pole jest wymagane" : ""),
      (value) =>
        typeof value === "string" && value.length >= 2
          ? ""
          : "Nazwisko musi mieć co najmniej 2 znaki",
      (value) =>
        /^[a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚŹŻ-]+$/.test(value as string)
          ? ""
          : "Nazwisko może zawierać tylko litery i znak '-'",
      (value) => (!/\s/.test(value as string) ? "" : "Nazwisko nie może zawierać spacji"),
    ],
  },
  {
    key: "birthDate",
    label: "Data urodzenia",
    value: "",
    required: true,
    type: "date",
    validators: [
      (value) => (!value ? "To pole jest wymagane" : ""),
      (value) => {
        if (validateYear(value) === "maxYear") {
          return "Rok nie może być późniejszy niż bieżący rok";
        } else if (validateYear(value) === "minYear") {
          return "Rok nie może być niższy niż 1950.";
        } else {
          return "";
        }
      },
    ],
  },
  {
    key: "gender",
    label: "Płeć",
    value: Gender.FEMALE,
    required: true,
    type: "select",
    options: getGenderOptions(),
  },
];

// ----------------------------------------------------- //
// ------------------ TABELE I LISTY ------------------- //
// ----------------------------------------------------- //

export const userParticipantsListDataGridColumns: GridColDef[] = [
  {
    field: "firstName",
    headerName: "Imię",
    flex: 1,
  },
  {
    field: "lastName",
    headerName: "Nazwisko",
    flex: 1,
  },
  {
    field: "birthDate",
    headerName: "Data urodzenia",
    type: "date",
    flex: 1,
  },
  {
    field: "gender",
    headerName: "Płeć",
    type: "string",
    flex: 1,
    renderCell: (params) => getGenderTranslation(params.value),
  },
];
